/* GridNumberEditor.js */

"use strict";
const _ = require("lodash");

class GridNumberEditor {
    constructor(args) {
        this.parentContainer = args.container;
        this.column = args.column;
        this.initialValue = {};
        this.field = args.column.field;
        this.grid = args.grid;

        this.numberInput = document.createElement("input");
        this.numberInput.setAttribute("type", "number");
        this.numberInput.classList.add("grid_number_editor");
        if (_.has(this.column, "fcdColumnDef.Number.max")) {
            this.numberInput.setAttribute("max", _.get(this.column, "fcdColumnDef.Number.max"));
        }
        if (_.has(this.column, "fcdColumnDef.Number.min")) {
            this.numberInput.setAttribute("min", _.get(this.column, "fcdColumnDef.Number.min"));
        }
        this.parentContainer[0].appendChild(this.numberInput);
    }

    static Formatter(row, cell, value, column /*, dataContext*/) {
        let displayElem = document.createElement("div");
        let currentValue = !_.isNumber(value) && _.isEmpty(value) ? "" : value;
        displayElem.innerText = currentValue;
        let max = _.get(column, "fcdColumnDef.Number.max", Number.MAX_SAFE_INTEGER);
        let min = _.get(column, "fcdColumnDef.Number.min", Number.MIN_SAFE_INTEGER);
        if (_.isNumber(currentValue) && (currentValue > max || currentValue < min)) {
            displayElem.classList.add("cell-error");
            displayElem.setAttribute("title", "Value outside of range: " + min + " - " + max);
        }

        let displayinfo = column.fcdColumnDef.displayinfo;
        displayElem.setAttribute("title", displayinfo.tooltip);
        displayElem.classList.add("grid_cell_view");

        return displayElem.outerHTML;
    }

    _registerListeners() {
        this.numberInput.addEventListener("click", (this._onClick = this._onClick.bind(this)));
        this.numberInput.addEventListener(
            "keydown",
            (this._onKeyPress = this._onKeyPress.bind(this))
        );
    }

    _unregisterListeners() {
        this.numberInput.removeEventListener("click", this._onClick);
        this.numberInput.removeEventListener("keydown", this._onKeyPress);
    }

    destroy() {
        this._unregisterListeners();
    }

    show() {
        this.numberInput.focus();
    }

    hide() {}

    position(position) {}

    focus() {
        this.numberInput.focus();
    }

    loadValue(item) {
        this.initialValue = item[this.field];
        this.numberInput.value = item[this.field];
        this._registerListeners();
    }

    getValue() {
        return _.isEmpty(this.numberInput.value) ? null : Number(this.numberInput.value);
    }

    setValue(value) {
        this.numberInput.value = value;
    }

    serializeValue() {
        return _.isEmpty(this.numberInput.value) ? null : Number(this.numberInput.value);
    }

    applyValue(item, state) {
        item[this.field] = state;
        this.initialValue = state;
    }

    isValueChanged() {
        return !_.isEqual(this.numberInput.value, this.initialValue);
    }

    validate() {
        return {
            valid: true,
            msg: null,
        };
    }

    _valueChanged() {}

    _onClick(event) {
        event.stopImmediatePropagation();
    }

    _onKeyPress(event) {
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.stopImmediatePropagation();
        }
    }
}

module.exports = GridNumberEditor;
